module.exports = __webpack_public_path__ + "img/symbol_15.621a6ebc.png";